import { ErrorSVG, TickSVG } from "./svg";
import classNames from "classnames";

export default function Alert({ message, className, isError = true }) {
  return (
    <>
      <div
        className={classNames(
          "p-2 my-2 rounded-lg text-sm text-center flex items-center justify-center",
          isError
            ? "text-error-red bg-alert-red"
            : "text-emerald-600 bg-emerald-100",
          className
        )}
        role="alert"
      >
        <span>
          {isError ? (
            <ErrorSVG className="mr-2" />
          ) : (
            <TickSVG className="mr-2" />
          )}
          {message}
        </span>
      </div>
    </>
  );
}
